import React from "react";
import { ReactComponent as DashboardIcon } from "./Icons/dashboard.svg";
import { ReactComponent as DiscoverIcon } from "./Icons/discover.svg";
import { ReactComponent as SequenceIcon } from "./Icons/sequence.svg";
import { ReactComponent as CallsIcon } from "./Icons/calls.svg";
import { ReactComponent as ContactIcon } from "./Icons/contact.svg";
import { ReactComponent as ReportsIcon } from "./Icons/reports.svg";
import { ReactComponent as TaskIcon } from "./Icons/task.svg";
import { ReactComponent as TemplateIcon } from "./Icons/template.svg";
import { ReactComponent as AccountsIcon } from "./Icons/accounts.svg";
import { ReactComponent as DataToolkitIcon } from "./Icons/dataToolkit.svg";
import { ReactComponent as AgentsIcon } from "./Icons/agents.svg";
import { ReactComponent as SignalsIcon } from "./Icons/signals.svg";
import { ReactComponent as PinIcon } from "./Icons/pin.svg";
import SparkleIcon from "Components/common/SparkleIcon";

// Material names here are all in the bundled (2019) Material Icons font.
const mi = name => (
  <i className="material-icons navMaterialIcon" aria-hidden="true">
    {name}
  </i>
);

export const NAV_ICONS = {
  home: <DashboardIcon />,
  listBuilder: <DiscoverIcon />,
  contacts: <ContactIcon />,
  accounts: <AccountsIcon />,
  signals: <SignalsIcon />,
  sequences: <SequenceIcon />,
  inbox: <i className="material-icons-outlined inboxIcon">mail</i>,
  tasks: <TaskIcon />,
  agents: <AgentsIcon />,
  copilot: <SparkleIcon />,
  templates: <TemplateIcon />,
  calls: <CallsIcon />,
  dataToolkit: <DataToolkitIcon />,
  reports: <ReportsIcon />,
  team: mi("people"),
  pricing: mi("credit_card"),
  settings: mi("settings")
};

export { PinIcon };
export const MoreIcon = () => mi("more_horiz");
export const ChevronIcon = ({ name = "chevron_right" }) => mi(name);
